module.exports = __webpack_public_path__ + "img/7_145.efc9cd9f.png";